import React from "react";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="main-hero-banner align-items-center justify-content-center d-flex">
        <p className="banner-text text-center mb-0">
          {t("aboutUsPage.aboutUs")} <br />
          <span className="mt-2">{t("aboutUsPage.aboutUsDescription")}</span>
        </p>
      </div>
      <div className="section2 container">
        <div className="heading">
          <h2 className="my-4">About Ebaa</h2>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-7 my-4">
            <p className="section2-text">
              At Ebaa, we believe in the power of tradition and the
              warmth of service. We are a platform designed to simplify the
              process of organizing religious and cultural events by offering
              two core services:
              <ul className="my-4">
                <li className="mb-3">
                  <strong>{t("aboutUsPage.qaariBooking_en")}</strong>{" "}
                  {t("aboutUsPage.qaariBooking")}
                </li>
                <li>
                  <strong>{t("aboutUsPage.cateringRestaurants_en")}</strong>{" "}
                  {t("aboutUsPage.cateringServices")}
                </li>
              </ul>
              {t("aboutUsPage.missionDescription")}
            </p>
          </div>
          <div className="col-md-5">
            <div className="">
              <img
                src="\assets\images\image-removebg-preview-Picsart-AiImageEnhancer.png"
                alt=""
                className="d-flex mx-auto d-none d-md-block"
                style={{ width: "300px" }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="section2 container">
        <div className="heading">
          <h2 className="my-4">{t("aboutUsPage.vision")}</h2>
        </div>
        <hr />
        <div className="row my-4">
          <div className="col-md-12">
            <p className="section2-text">
              {t("aboutUsPage.visionDescription")}
              <ul className="my-4">
                <li className="mb-3">{t("aboutUsPage.visionPoint1")}</li>
                <li className="mb-3">{t("aboutUsPage.visionPoint2")}</li>
                <li>{t("aboutUsPage.visionPoint3")}</li>
              </ul>
              At Ebaa, we blend devotion with service—offering a one-stop
              solution to book Qaari for your events and order delicious food
              from trusted restaurants. With heart, heritage, and hospitality at
              our core, we’re here to make your moments meaningful.
            </p>
          </div>
        </div>
      </div>
      <div className="section2 container">
        <div className="heading">
          <h2 className="my-4">{t("aboutUsPage.whyChooseUs")}</h2>
        </div>
        <hr />
        <div className="row my-5 d-flex justify-content-around">
          <div className="col-md-5 mb-5">
            <div className="section-1">
              <div className="d-flex gap-4 section-1-heading mb-2">
                <span>01</span>
                <p>{t("aboutUsPage.point1Title")}</p>
              </div>
              <p>{t("aboutUsPage.point1Description")}</p>
            </div>
          </div>
          <div className="col-md-5 mb-5">
            <div className="section-1">
              <div className="d-flex gap-4 section-1-heading mb-2">
                <span>02</span>
                <p>{t("aboutUsPage.point2Title")}</p>
              </div>
              <p>{t("aboutUsPage.point2Description")}</p>
            </div>
          </div>
          <div className="col-md-5 mb-5">
            <div className="section-1">
              <div className="d-flex gap-4 section-1-heading mb-2">
                <span>03</span>
                <p>{t("aboutUsPage.point3Title")}</p>
              </div>
              <p>{t("aboutUsPage.point3Description")}</p>
            </div>
          </div>
          <div className="col-md-5 mb-5">
            <div className="section-1">
              <div className="d-flex gap-4 section-1-heading mb-2">
                <span>04</span>
                <p>{t("aboutUsPage.point4Title")}</p>
              </div>
              <p>{t("aboutUsPage.point4Description")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
